import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Card, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import meta from '../../../../../meta';
import { CiatAppContext } from '../../../../../providers';
import api from '../../../../../api/req';

function ChangePassword({ closeShowPassword }) {
  const { currentUser, auth } = useContext(CiatAppContext);

  const [formData, setFormData] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const r = await api.post$(`${meta.cat.user.backendURL}${currentUser.id}/change_password/`, auth, {
      old_password: formData.oldPassword,
      new_password: formData.newPassword,
      confirm_password: formData.confirmPassword,
    });
    if (r.ok) {
      toast.success('Пароль успішно оновлено', { theme: 'colored' });
      closeShowPassword();
    } else {
      const errorData = await r.json();
      const errorMessages = Object.values(errorData).flat();
      errorMessages.forEach(
        (v) => {
          toast.error(`Виникла помилка ${v}`, { theme: 'colored' });
        },
      );
    }
  };

  return (
    <Card className="mb-3">
      <Card.Body className="bg-light">
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="oldPassword">
            <Form.Label>Старий пароль</Form.Label>
            <Form.Control
              type="text"
              value={formData.oldPassword}
              name="oldPassword"
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="newPassword">
            <Form.Label>Новий пароль</Form.Label>
            <Form.Control
              type="text"
              value={formData.newPassword}
              name="newPassword"
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="confirmPassword">
            <Form.Label>Підтвердження паролю</Form.Label>
            <Form.Control
              type="text"
              value={formData.confirmPassword}
              name="confirmPassword"
              onChange={handleChange}
            />
          </Form.Group>
          <Button className="w-100" type="submit">
            Оновити пароль
          </Button>
        </Form>
      </Card.Body>
    </Card>
  );
}

ChangePassword.propTypes = {
  closeShowPassword: PropTypes.func.isRequired,
};

export default ChangePassword;
